import { Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./style.module.scss";
import { TopHead } from "./top-head";
import { GypTopHead } from "./gyp-top-head";

export type HeaderProps = {
  noTabs?: boolean;
  isGYP?: boolean;
};

export const Header = (props: HeaderProps) => {
  const { noTabs = false, isGYP = false } = props;
  const [activeKey, setActiveKey] = useState("supplier");
  const navigate = useNavigate();

  const onTypeChange = useCallback((key: string) => {
    setActiveKey(key);
    if (key === "businessOpportunity") {
      window.location.href = `${process.env.YCX_HOME}`;
    }
  }, []);

  useEffect(() => {
    if (activeKey === "supplier") {
      const inkBar = document.querySelector(".ant-tabs-ink-bar");
      if (inkBar) {
        // 设置class ant-tabs-ink-bar
        (inkBar as HTMLElement).classList.add("ant-tabs-ink-bar-supplier");
      }
    }
  }, [activeKey]);

  return (
    <>
      <div className={style.outerHeaderWrapper}>
        {isGYP ? <GypTopHead /> : <TopHead />}
      </div>
      {noTabs ? null : (
        <div
          className={style.outerHeaderWrapper}
          style={{ border: "none", background: "#fff" }}
        >
          <div className={style.headerContent}>
            <img
              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/logo.png"
              className={style.headerLogo}
              alt="Logo"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/s");
              }}
            />
            <div className={style.headerTab}>
              <Tabs
                defaultActiveKey="supplier"
                onChange={onTypeChange}
                activeKey={activeKey}
                items={[
                  {
                    label: `找商机`,
                    key: "businessOpportunity",
                  },
                  {
                    label: `找供应商`,
                    key: "supplier",
                  },
                ]}
              />
            </div>
            <img
              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/logoRIght.svg"
              className={style.descLogo}
              alt="Logo"
            />
          </div>
        </div>
      )}
    </>
  );
};
